import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class BigMushroom2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.BIG_MUSHROOM2;
}

export default BigMushroom2PoiTileEntity;
